import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_dashboard",
  "use": "svg_dashboard-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_dashboard\"><rect x=\"10.5\" y=\".5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"currentColor\" /><rect x=\".5\" y=\".5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"currentColor\" /><rect x=\"10.5\" y=\"10.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"currentColor\" /><rect x=\".5\" y=\"10.5\" width=\"7\" height=\"7\" rx=\"1.5\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol